import Banner from '../components/containers/HomePage/Banner';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { get } from '../utils/axios';
import QuickContact from '../components/common/QuickContact';
import DetailButton from '../components/common/DetailButton';
import AddToCartButton from '../components/common/AddToCartButton';
import Testimonial from './Testimonial';
import Swal from 'sweetalert2';

function Home() {

  let [packages, setPackages] = useState([]);
  let [board, setBoard] = useState([]);
  let [upcomingMock, setUpcomingMock] = useState([]);

  let [fakeData, setFakeData] = useState('');


  const getPackagesData = () => {
    get(`/packages`)
      .then((res) => {
        if (res.success) {
          setPackages(res.data);
        }
      })
  };

  const getBoardData = () => {
    get(`/board`)
      .then((res) => {
        if (res.success) {
          setBoard(res.data);
        }
      })
  };

  const getUpComingMockData = () => {
    get(`/upcoming-mock`)
      .then((res) => {
        if (res.success) {
          setUpcomingMock(res.data);
        }
      })
  };

  const getFakeData = () => {
    get(`/userCount`, false)
      .then((res) => {
        if (res.success) {
          setFakeData(res.data);
          if (document.getElementsByClassName('quickMessage')) {
            document.getElementsByClassName('quickMessage')[0].style.display = "block";
          }
          setTimeout(() => {
            document.getElementById("fake-data") && document.getElementById("fake-data").click();
          }, 4000);
        }
      })
  };

  const showIncomingAlert = () => {
    Swal.fire(
      {
        title: 'Launching Soon. Stay tuned!!',
        icon: 'info'
      }
    )
  }


  useEffect(() => {
    getFakeData();

    setInterval(() => {
      getFakeData();
    }, 1000 * 60);

    getPackagesData();
    getBoardData();
    getUpComingMockData();

  }, []);

  return (
    <>
      <Banner />

      {/* <!--Start Our Services--> */}
      <section id="servicessection" className="wow fadeInUp">
        <div className="container">
          <h2 className="mainHeading">Our Services</h2>
          <h3 className="mainsubHeading">Popular Topics to Learn</h3>
          <div className="serviceWrap">

            <div className="servicebox">
              <div className="serImg"><img src="images/exam-copy.png" alt="" /></div>
              <h4>Mock Exams</h4>
              <p>Mock exams are created by highly trained teachers to cover popular boards to give real time experience.</p>
              <div className="mainCtablock">
                <Link to="/mock-exam" className="maincta"><span>Get Started </span><img src="images/arrow.svg" alt="" /></Link>
              </div>
            </div>

            <div className="servicebox">
              <div className="serImg"><img src="images/mark.png" alt="" /></div>
              <h4>Practice Papers</h4>
              <p>Practice papers help students in identifying their shortcomings. With adaptive learning, students will get custom learning experiences that address the unique needs of an individual.</p>
              <div className="mainCtablock">
                <Link to="/practice-paper" className="maincta"><span>Get Started </span><img src="images/arrow.svg" alt="" /></Link>
              </div>
            </div>

            <div className="servicebox">
              <div className="serImg"><img src="images/post-papper.png" alt="" /></div>
              <h4>Past Papers</h4>
              <p>Solved Past papers of different exam boards with model answers will help students to understand exams patterns.</p>
              <div className="mainCtablock">
                <Link to="/past-paper" className="maincta"><span>Get Started </span><img src="images/arrow.svg" alt="" /></Link>
              </div>
            </div>

            <div className="servicebox">
              <div className="serImg"><img src="images/tution-1.png" alt="" /></div>
              <h4>Tuition</h4>
              <p>Our excellent tuition services include several subjects for different grades that designed to help students' needs.</p>
              <div className="mainCtablock">
                {/* <Link to="/tuitions" className="maincta"><span>Get Started </span><img src="images/arrow.svg" alt="" /></Link> */}
                <a href onClick={showIncomingAlert} className="maincta"><span>Get Started </span><img src="images/arrow.svg" alt="" /></a>
              </div>
            </div>

          </div>
        </div>
      </section>
      {/* <!--End Our Services--> */}

      {/* <!--Start Upcoming Mock Exams MCQs--> */}
      {upcomingMock && upcomingMock.length > 0 &&

        <section className="upcomingMockwrap">
          <div className="container wow fadeInDown">
            <h2 className="mainHeading">Featured Mock Exams</h2>
            {/*<h3 className="mainsubHeading">MCQs</h3>*/}
            <div className="upcomingWrap">
              {upcomingMock.map((item, index) => {
                return (item && index < 4 &&
                  <div className="upcomingBox" key={item._id}>
                    <div className="upImg"><img src={item.image && item.image.length > 0 ? item.image : "images/Mask-Group.png"} alt="" height="180" /></div>
                    <div className="upContent">
                      <h5>{item.name}</h5>
                      {/* <h6>11 + Math Exams</h6> */}
                      <div className="offer">
                        {item.sellingPrice ? <>
                          <span className="offerbefore">Regular : £{item.displayPrice}</span>
                          <span className="mainOffer">Offer : £{item.sellingPrice}</span>
                        </> :
                          <span className="mainOffer">Free</span>
                        }

                      </div>

                      <div style={{ display: 'inline-flex' }}>
                        <div className="mainCtablock" style={{ margin: '2px' }}>

                          <DetailButton state={{ product: item }} to={`/product-details`} />
                          <AddToCartButton product={item} id={item._id} name={'Package'} to={`/take-mock-exam/${item._id}`} price={item.sellingPrice} />

                        </div>

                      </div>


                    </div>
                  </div>
                )
              })}

            </div>

            {upcomingMock.length > 3 && <div style={{ display: 'flex', justifyContent: 'center', }}><Link to="/mcq" className="mcqButton" >View More</Link></div>}

          </div>
        </section>
      }
      {/* <!--End Upcoming Mock Exams MCQs--> */}

      {/* <!--Start Latest Products--> */}
      {packages && packages.length > 0 && <section id="latestProductswrapper" className="wow fadeInUp">
        <div className="container">
          <h2 className="mainHeading">Latest </h2>
          <h3 className="mainsubHeading">Featured Products</h3>

          <div className="featuredProductsWrap">

            {packages && packages.length > 0 && packages.map((item, index) => {
              return (index < 3 && <div className="featuredProducts" key={index}>
                <div className="fimageBlock"><img src={item.image ? item.image : "images/featuredProducts.jpeg"} alt="" /></div>
                <h6>{item.name}</h6>
                <div className="offer">
                  <span className="offerbefore">Regular : £{item.displayPrice}</span>
                  <span className="mainOffer">Offer : £{item.sellingPrice}
                  </span></div>

                <div className="mainCtablock">

                  <DetailButton state={{ product: item }} to={`/product-details`} />
                  <AddToCartButton product={item} id={item._id} name={'Package'} />

                </div>

              </div>)
            })}

          </div>

          {packages.length > 3 && <div style={{ display: 'flex', justifyContent: 'center' }}><Link to="/product" style={{ color: 'white', textAlign: 'center', border: 'solid 1px white', padding: '10px', borderRadius: '4px', marginTop: '40px' }}>View More</Link></div>}

        </div>
      </section>}
      {/* <!--End Latest Products--> */}

      {/* <!--Start Exam Test Papers Popular Topics to Learn--> */}
      <section id="examTestPapers" className="wow fadeInUp">
        <div className="container">
          <h2 className="mainHeading">Exam Test Papers</h2>
          <h3 className="mainsubHeading">Popular Boards</h3>
          <div className="serviceWrap">

            {board && board.length > 0 && board.map((item, index) => {
              return (index < 3 && <Link to="/book-exam-online" state={{ selected: item._id, status: 'online' }} className="servicebox" key={index}>
                <div className="serImg"><img src={item.image && item.image.trim().length > 0 ? item.image.trim() : "images/tution-1.png"} alt="" /></div>
                <h4>{item.name}</h4>
                {item.description && <p dangerouslySetInnerHTML={{ __html: item.description }}></p>}
              </Link>)
            })}

          </div>
        </div>
      </section>
      {/* <!--End Exam Test Papers Popular Topics to Learn--> */}

      {/* <!--Start Exam Test Papers Popular Topics to Learn--> */}
      <section id="funfactwrap" className="">
        <div className="container wow fadeInUp">

          <h3 className="mainsubHeading">Strength in Numbers</h3>
          <div className="serviceWrap">

            <ul id="counter">
              <li><span> <span className="counter-value" data-count="25">0 </span> K+</span>
                <div>Learners & Counting</div>
              </li>
              <li> <span><span className="counter-value" data-count="10">0 </span>K+</span>
                <div>Total Courses</div>
              </li>
              {/* <li> <span><span className="counter-value" data-count="18">0</span>+</span>
                <div>Languages</div>
              </li> */}
              <li> <span><span className="counter-value" data-count="99">0</span>%</span>
                <div>Successful Students</div>
              </li>
            </ul>


          </div>
        </div>
      </section>
      {/* <!--End Exam Test Papers Popular Topics to Learn--> */}

      {/* <!--Start What Our Students Says--> */}
      <Testimonial />
      {/* <!--End What Our Students Says--> */}

      {/* <!--Start Newsletter--> */}
      {/* <section id="newsletterwrap" className="wow fadeInUp">
        <div className="container">
          <div className="newslettercontainer">
            <div className="textBolck">
              <div><img src="images/plaine.png" alt="" /></div>
              <div>SUBSCRIBE TO OUR NEWSLETTER</div>
            </div>
            <div className="subscribInput">
              <form action="">
                <input type="email" placeholder="enter your email id" />
                <button type="button">GO</button>
              </form>
            </div>
          </div>
        </div>
      </section> */}
      {/* <!--End Start Newsletter--> */}

      <QuickContact upcomingMock={upcomingMock} board={board} />
      {fakeData && fakeData.length > 0 && (<div className="quickMessage">
        <span id='fake-data' className="closeIcon" onClick={() => document.getElementsByClassName('quickMessage')[0].style.display = "none"}><img src="/images/crossIocn.png" alt="close" /></span>
        <p>{fakeData}</p>
      </div>)}
    </>
  );
}

export default Home;
